import i18n from '../../utils/i18n';

const getDefaultLabels = () => ({
  individualModeLabel: i18n.t('communication.modal.individualModeLabel'),
  groupModeLabel: i18n.t('communication.modal.groupModeLabel'),
  individualPlaceholder: i18n.t('communication.modal.individualPlaceholder'),
  groupPlaceholder: i18n.t('communication.modal.groupPlaceholder'),
  pcPlaceholder: i18n.t('communication.tipSelectorPlaceholder'),
  modalTitle: i18n.t('communication.newMessage'),
  previewTitle: i18n.t('communication.modal.previewTitle'),
});

export const MODAL_CONFIGS = {
  DEFAULT: {
    allowModeSwitch: true,
    allowTranslation: true,
    allowContentSelection: true,
    forcePreview: false,
    showAgeRanges: true,
    defaultMode: 'individual',
    showCardSelector: true,
    showTipSelector: true,
    labels: getDefaultLabels()
  },
  LIBRARY_SEND_CARD: {
    allowModeSwitch: true,
    allowTranslation: true,
    allowContentSelection: true,
    forcePreview: false,
    showAgeRanges: true,
    defaultMode: 'individual',
    showCardSelector: true,
    showTipSelector: true,
    labels: getDefaultLabels()
  },
  LIBRARY_SEND_TIP: {
    allowModeSwitch: true,
    allowTranslation: true,
    allowContentSelection: true,
    forcePreview: false,
    showAgeRanges: true,
    defaultMode: 'individual',
    showCardSelector: true,
    showTipSelector: true,
    labels: getDefaultLabels()
  },
  TRANSLATE_ONLY: {
    allowModeSwitch: false,
    allowTranslation: true,
    allowContentSelection: true,
    forcePreview: true,
    showAgeRanges: false,
    defaultMode: 'individual',
    showCardSelector: true,
    showTipSelector: true,
    labels: getDefaultLabels()
  }
};

/**
 * Creates a modal configuration by merging a preset with custom overrides
 * @param {string} preset - Preset name ('DEFAULT', 'LIBRARY_SEND_CARD', 'LIBRARY_SEND_TIP', 'TRANSLATE_ONLY')
 * @param {Object} overrides - Custom configuration to override preset values
 * @returns {Object} - Merged configuration object
 */
export const createModalConfig = (preset = 'DEFAULT', overrides = {}) => {
  const baseConfig = MODAL_CONFIGS[preset] || MODAL_CONFIGS.DEFAULT;

  return {
    ...baseConfig,
    ...overrides,
    labels: { ...baseConfig.labels, ...(overrides.labels || {}) }
  };
};
